module.exports = __webpack_public_path__ + "static/media/75D78A05-8F85-4F9F-BA23-F2DEE1780149-removebg-preview.45d68f5a.png";